var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Errors = /** @class */ (function () {
    function Errors() {
        this.errors = {};
    }
    Errors.createAndThrowFromException = function (exception, prefix) {
        var errors = Errors.createFromException(exception, prefix);
        if (errors) {
            throw errors;
        }
    };
    Errors.createFromException = function (exception, prefix) {
        var errors = Errors.getErrorsFromException(exception, prefix);
        if (!errors) {
            return null;
        }
        var errorsObject = new Errors();
        errorsObject.populate(errors);
        return errorsObject;
    };
    Errors.getErrorsFromResponse = function (response, prefix) {
        if (!response.data || !response.data.errors) {
            return null;
        }
        if (!prefix) {
            return response.data.errors;
        }
        var errors = {};
        var keys = Object.keys(response.data.errors);
        keys.forEach(function (key) {
            if (-1 === key.indexOf(prefix + ".")) {
                return;
            }
            errors[key.replace(prefix + ".", '')] = response.data.errors[key];
        });
        return errors;
    };
    Errors.getErrorsFromException = function (exception, prefix) {
        if (!exception.response || !exception.response.status || 422 !== exception.response.status) {
            return null;
        }
        return Errors.getErrorsFromResponse(exception.response, prefix);
    };
    Errors.prototype.has = function (key) {
        return this.errors.hasOwnProperty(key);
    };
    Errors.prototype.get = function (key) {
        if (!this.has(key)) {
            return null;
        }
        var error = this.errors[key];
        if (error instanceof Array) {
            return error[0];
        }
        return error;
    };
    Errors.prototype.add = function (key, message) {
        var _a;
        this.errors = __assign(__assign({}, this.errors), (_a = {}, _a[key] = message, _a));
    };
    Errors.prototype.all = function () {
        return this.errors;
    };
    Errors.prototype.any = function () {
        return Object.keys(this.errors).length > 0;
    };
    Errors.prototype.populate = function (errors) {
        this.errors = __assign({}, errors);
    };
    Errors.prototype.reset = function () {
        this.errors = {};
    };
    Errors.prototype.populateFromResponse = function (response, prefix) {
        var errors = Errors.getErrorsFromResponse(response, prefix);
        if (!errors) {
            return;
        }
        this.populate(errors);
    };
    return Errors;
}());
export default Errors;
